import { render, staticRenderFns } from "./KebijakanPrivasi.vue?vue&type=template&id=05727a76&scoped=true"
var script = {}
import style0 from "./KebijakanPrivasi.vue?vue&type=style&index=0&id=05727a76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05727a76",
  null
  
)

export default component.exports